export enum ProviderType {
  chiropractic = 0,
  primaryCare = 1,
  mentalHealth = 2,
  labs = 3,
  imaging = 4,
  dental = 5,
  pharmacy = 6,
  specialist = 7,
  other = 8,
}

export const ProviderTypeLabels: Record<ProviderType, string> = {
  [ProviderType.chiropractic]: 'Chiropractic',
  [ProviderType.primaryCare]: 'Primary Care',
  [ProviderType.mentalHealth]: 'Mental Health',
  [ProviderType.labs]: 'Laboratory',
  [ProviderType.imaging]: 'Imaging',
  [ProviderType.dental]: 'Dental',
  [ProviderType.pharmacy]: 'Pharmacy',
  [ProviderType.specialist]: 'Specialist',
  [ProviderType.other]: 'Other',
};

export interface Provider {
  id: string;
  userId?: string;
  email?: string;
  name: string;
  type: ProviderType;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  latitude?: number;
  longitude?: number;
  phoneNumber?: string;
  website?: string;
  averageCashPrice?: number;
  servicePrices?: Record<string, number>;
  rating?: number;
  totalReviews?: number;
  isFairCarePreferred: boolean;
  acceptsCash: boolean;
  isSubscribed: boolean;
  stripeAccountId?: string;
  subscriptionTier?: 'basic' | 'pro' | 'enterprise';
  subscriptionExpiresAt?: Date;
  specialties: string[];
  metadata?: Record<string, unknown>;
  createdAt: Date;
  lastUpdated: Date;
}

export interface ProviderStats {
  totalProviders: number;
  subscribedProviders: number;
  preferredProviders: number;
  providerTypes: number;
  totalVisits?: number;
  totalRevenue?: number;
}

